import { Box } from '@bechtel/gds';
import { FC } from 'react';
import { MetadataText } from '~/components/atoms';
import { UserInfo } from '../user-info';
import { UpdatedByProps } from './types';

export const UpdatedBy: FC<UpdatedByProps> = ({ metadataTable, userAccount, updatedTime, updatedBy }) => {
  return (
    <Box
      pt={{ sm: '450' }}
      mb={{ sm: '300' }}
      pr={{ sm: '300' }}
      flexDirection={{ sm: 'column' }}
      css={`
        ${({ theme }) => `border-bottom: 1px solid ${theme.colors.grey[200]};`}
      `}
    >
      <Box
        py={{ sm: '400' }}
        css={`
          ${({ theme }) => `border-bottom: 1px solid ${theme.colors.primary[900]};`}
        `}
      >
        <MetadataText
          size="400"
          color="primary.900"
          weight="600"
          metadataTable={metadataTable}
          memberName="updatedBy"
        />
      </Box>
      {(userAccount || updatedBy) && (
        <Box pr={{ sm: '300' }}>
          <UserInfo userAccount={userAccount} updatedBy={updatedBy} updatedTime={updatedTime} />
        </Box>
      )}
    </Box>
  );
};
